import { render, staticRenderFns } from "./share-planner-users.vue?vue&type=template&id=45428053&scoped=true&"
import script from "./share-planner-users.vue?vue&type=script&lang=ts&"
export * from "./share-planner-users.vue?vue&type=script&lang=ts&"
import style0 from "./share-planner-users.vue?vue&type=style&index=0&id=45428053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45428053",
  null
  
)

export default component.exports